module.exports = __webpack_public_path__ + "img/ic-white-eventos-actividades.80ef7b42.svg";